import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { PlanoContingencia } from "../models/plano-contingencia/plano-contingencia";
import { DefaultResponse } from "../models/DefaultResponse";

@Injectable({
  providedIn: 'root'
})
export class PlanoContingenciaService {
  private api = ConvivaApi;

  constructor(private http: HttpClient) { }

  public setCadastrarPlano(plano: PlanoContingencia): Observable<DefaultResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    return this.http.post<DefaultResponse>(
      `${this.api.PlanoContingencia.setCadastrarPlano}`, 
      plano,
      { headers }
    ).pipe(map((response: DefaultResponse) => response));
  }

  public setAtualizarPlano(plano: PlanoContingencia): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(`${this.api.PlanoContingencia.setAtualizarPlano}`, plano)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getPlanosPorEscolaEStatus(codigoEscola: number, status: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(
      `${this.api.PlanoContingencia.getPlanosPorEscolaEStatus}?codigoEscola=${codigoEscola}&status=${status}`
    ).pipe(map((response: DefaultResponse) => response));
  }

  public getPlanosPorDiretoriaEscolaEStatus(codigoDiretoria: number, codigoEscola: number, status: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(
      `${this.api.PlanoContingencia.getPlanosPorDiretoriaEscolaEStatus}?codigoDiretoria=${codigoDiretoria}&codigoEscola=${codigoEscola}&status=${status}`
    ).pipe(map((response: DefaultResponse) => response));
  }

  public getPlanos(codigoPolo: number, codigoDiretoria: number, codigoEscola: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(
      `${this.api.PlanoContingencia.getPlanos}?codigoPolo=${codigoPolo}&codigoDiretoria=${codigoDiretoria}&codigoEscola=${codigoEscola}`
    ).pipe(map((response: DefaultResponse) => response));
  }

  public getPlanoById(idPlano: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(
      `${this.api.PlanoContingencia.getPlanoById}?codigoPlano=${idPlano}`
    ).pipe(map((response: DefaultResponse) => response));
  }

  public setPlanoAprovado(parametros: { codigoPlano: number; codigoPerfil: number; nomePerfil: string }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      this.api.PlanoContingencia.setPlanoAprovado,
      parametros
    ).pipe(map((response: DefaultResponse) => response));
  }

  public setPlanoReprovado(parametros: { codigoPlano: number; codigoPerfil: number; nomePerfil: string; justificativa: string }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      this.api.PlanoContingencia.setPlanoReprovado,
      parametros
    ).pipe(map((response: DefaultResponse) => response));
  }

  public setEliminarPlano(parametros: { codigoPlano: number; codigoPerfil: number; nomePerfil: string }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      this.api.PlanoContingencia.setEliminarPlano,
      parametros
    ).pipe(map((response: DefaultResponse) => response));
  }

  public setEnviarParaValidacao(parametros: { codigoPlano: number; codigoUsuario: number; codigoPerfil: number; nomePerfil: string }): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      this.api.PlanoContingencia.setEnviarParaValidacao,
      parametros
    ).pipe(map((response: DefaultResponse) => response));
  }

}
